import { CheckCircle as CheckIcon, Error as ErrorIcon } from '@mui/icons-material';
import { Box, Chip, List, ListItem, ListItemText, useTheme } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useMemo } from 'react';
import { tableConfig } from '../../../commons/table/config/tableConfig';

const XmlValidationTable = ({ validations }) => {
    const theme = useTheme();

    const columns = useMemo(() => [
        {
            accessorKey: 'tag',
            header: 'Tag XML',
            size: 150,
            Cell: ({ cell }) => (
                <Box sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
                    {cell.getValue()}
                </Box>
            ),
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'value',
            header: 'Contenido',
            size: 400,
            Cell: ({ cell }) => (
                <Box
                    sx={{
                        fontFamily: 'monospace',
                    }}
                >
                    {cell.getValue()}
                </Box>
            ),
        },
        {
            accessorKey: 'message',
            header: 'Errores',
            size: 350,
            sortingFn: (rowA, rowB) => {
                const errorsA = rowA.original.message.length;
                const errorsB = rowB.original.message.length;
                return errorsA - errorsB;
            },
            Cell: ({ cell }) => {
                const errors = cell.getValue();

                if (errors.length === 0) {
                    return (
                        <Chip
                            icon={<CheckIcon />}
                            label="Sin errores"
                            color="success"
                            variant="outlined"
                            size="small"
                        />
                    );
                }

                return (
                    <Box>
                        <Chip
                            icon={<ErrorIcon />}
                            label={`${errors.length} error${errors.length > 1 ? 'es' : ''}`}
                            color="error"
                            variant="outlined"
                            size="small"
                            sx={{ mb: 1 }}
                        />
                        <List dense sx={{ padding: 0 }}>
                            {errors.map((error, index) => (
                                <ListItem key={index} sx={{ alignItems: 'flex-start' }}>
                                    <ListItemText
                                        primary={`• ${error}`}
                                        sx={{
                                            margin: 0,
                                            '& .MuiListItemText-primary': {
                                                color: theme.palette.error.main,
                                                whiteSpace: 'pre-line',
                                            }
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                );
            },
        },
    ], [theme]);

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: validations.data,
        state: { isLoading: validations.isFetching },
        enableColumnOrdering: false,
        enableGrouping: true,
        enableColumnPinning: true,
        enableFacetedValues: true,
        enableRowSelection: false,
        initialState: {
            density: 'compact',
            showColumnFilters: true,
            showGlobalFilter: true,
        },
    });

    return (
        <Box sx={{ padding: 2 }}>
            <MaterialReactTable table={table} />
        </Box>
    );
};

export default XmlValidationTable;
